/* File: assets/product-bundles-single-add.js
 * Single product add (Minimog-compatible):
 * - Add via /cart/add.js mit Sections
 * - Minimog bekommt vollständiges Response-Objekt (inkl. Sections)
 * - Drawer öffnet sofort mit aktualisiertem Inhalt
 */

(function () {
  'use strict';

  /* ============== Helpers ============== */

  function setLoading(btn, isLoading) {
    if (!btn) return;
    btn.disabled = !!isLoading;
    btn.classList.toggle('is-loading', !!isLoading);
    const icon = btn.querySelector('.m-spinner-icon');
    if (icon) icon.style.display = isLoading ? 'inline-flex' : 'none';
  }

  function showError(el, msg) {
    try {
      const root = el?.closest('[data-section-id]') || document;
      const box = root.querySelector('.product-bundles__error');
      if (box) {
        box.textContent = msg || '';
        box.className = 'product-bundles__error error';
      }
    } catch (_) {}
  }

  async function addSingleWithSections(variantId, qty) {
    // Sections sammeln (Minimog fügt seine eigenen dazu)
    let sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );

    const payload = {
      items: [{ id: Number(variantId), quantity: Number(qty || 1) }],
      sections,
      sections_url: window.location.pathname
    };

    const res = await fetch(window.MinimogSettings.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
    if (!res.ok) throw new Error(await res.text().catch(() => 'Add failed'));
    return res.json(); // enthält cart + sections HTML
  }

  function openDrawer() {
    let opened = false;
    try {
      const drawer = document.querySelector('m-cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        opened = true;
      }
    } catch (_) {}
    if (!opened) {
      try {
        const trigger =
          document.querySelector('[data-cart-toggle]') ||
          document.querySelector('[data-drawer-toggle="cart"]') ||
          document.querySelector('[data-drawer-trigger="cart"]') ||
          document.querySelector('a[href="#cart"]');
        if (trigger) { trigger.click(); opened = true; }
      } catch (_) {}
    }
    return opened;
  }

  /* ============== Main ============== */

  const SINGLE_SELECTOR = '[data-add-bundle-single]';

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest(SINGLE_SELECTOR);
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation(); // sicherstellen, dass kein alter Handler läuft

    const variantId = btn.getAttribute('data-variant-id');
    const qty = btn.getAttribute('data-quantity') || '1';

    try {
      showError(btn, '');
      setLoading(btn, true);

      // Nur diese Variante hinzufügen
      const response = await addSingleWithSections(variantId, qty);

      // Minimog informieren
      if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
      }

      // Sections ersetzen, falls Theme das nicht automatisch macht
      if (response.sections) {
        Object.entries(response.sections).forEach(([id, html]) => {
          const el =
            document.getElementById(`shopify-section-${id}`) ||
            document.querySelector(`[data-section-id="${id}"]`);
          if (el) el.innerHTML = html;
        });
      }

      openDrawer();
    } catch (err) {
      console.error(err);
      showError(btn, 'Konnte das Produkt nicht hinzufügen.');
    } finally {
      setLoading(btn, false);
    }
  }, true);
})();
